/**
  * feApiEndpoint point to the routes/fe-api
  * folder. If changed then the folder should be
  * moved. (I believe).
*/
export const feApiEndpoint = '/fe-api';
